import goods from '../services/goods';
import utils from '../libs/utils';

export default {
  data() {
    return {
      approvalNumberTypeArr: [
        '国药准字',
        '进口注册证号',
        '医药产品注册证',
        '国药试字',
        '国药准字HJ',
        '国药准字ZJ',
        '国药准字SJ',
        '国药准字HC',
        '国药准字ZC',
        '国药准字SC',
      ],
    };
  },
  computed: {
    typeName() {
      const result = utils.handleGoodsTypeStr(this.typeId);
      // this.goodsTypes.forEach((item) => {
      //   if (this.typeId === item.value) {
      //     result = item.name;
      //   }
      // });
      return result;
    },
    goodsTypes() {
      if (this.ready) {
        return this.$store.state.publicParams.goodsTypes;
      }
      return [];
    },
  },
  methods: {
    getAllLabels(type) {
      this.baseData.label.gspArr = [];
      this.baseData.label.bizArr = [];
      this.baseData.label.prodArr = [];
      this.baseData.label.otherArr = [];
      console.log(type);

      return new Promise((resolve) => {
        goods.listGoodsLabels({ status: 1 }).then((res) => {
          if (res.data.status === 200) {
            const { list } = res.data.data;
            list.forEach((item) => {
              const { categoryIdList, goodsTypeIdList } = item;
              if (goodsTypeIdList.includes(type * 1)) {
                if (categoryIdList.includes(1)) {
                  this.baseData.label.gspArr.push(item);
                }
                if (categoryIdList.includes(2)) {
                  this.baseData.label.bizArr.push(item);
                }
                if (categoryIdList.includes(3)) {
                  this.baseData.label.prodArr.push(item);
                }
                if (categoryIdList.includes(4)) {
                  this.baseData.label.otherArr.push(item);
                }
              }
            });
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    handleGoodsApprovalType(typesList, value) {
      let typeStr = '';
      let result = value;

      typesList.forEach((str) => {
        if (value.includes(str)) {
          typeStr.length <= str.length && (typeStr = str);
        }
      });
      result = result.replace(typeStr, '');

      return {
        result,
        typeStr,
      };
    },
    fetchListIndications() {
      function handleIndications(item) {
        const res = {
          value: `${item.id}`,
          label: item.goodsIndicationDicName,
        };
        if (item.childGoodsIndicationDicVOs.length) {
          res.children = [];
          item.childGoodsIndicationDicVOs.forEach((data) => {
            res.children.push(handleIndications(data));
          });
        }
        return res;
      }
      return new Promise((resolve) => {
        goods.listIndications().then((res) => {
          const status = res.data.status;
          const resData = [];
          if (status === 200) {
            const data = res.data.data;
            data.forEach((item) => {
              resData.push(handleIndications(item));
            });
            this.baseData.indicationTree = resData;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
  },
};
